import React, { useEffect, useCallback, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getDetailEntete, getDetailLigneEntete, updateReclamationAll } from "../../Redux/reclamationReduce";
import ImprimerReclamation from "./ImprimerReclamation";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import Configuration from "../../configuration";
function ModifierReclamationAll({ client, obj }) {
  const dispatch = useDispatch();
  const location = useParams();
  var idReclamation = location.id;
  var id = location.id;
  var idClaim = location.id;
  var token = localStorage.getItem("x-access-token");
  const saveTableCalled = useRef(false);
  var decoded = jwt_decode(token);

  //input
  const [data, setData] = React.useState([]);
  const [reclamation, setReclamation] = React.useState({});
  const [commentaire, setCommentaire] = React.useState(null);
  const [loader, setLoader] = React.useState(true);

  /* detailReclamation */
  const detailReclamation = useCallback(async (idReclamation) => {
    var det = await dispatch(getDetailLigneEntete({ idReclamation }));
    var dataD = await det.payload;
    setData(dataD)
    setLoader(false)
    var dataReclamation = await dispatch(getDetailEntete({ idReclamation }));
    var reclamationD = await dataReclamation.payload;
    setReclamation(reclamationD);
  }, [dispatch, idReclamation]);


  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  const handleupdateRec = async (traiter,type_reclamation) => {
    if (idClaim) {
      dispatch(updateReclamationAll({ data, idClaim, traiter, commentaire, id_role: obj.user.id_role,type_reclamation,client })).then((e) => {
        if (e.payload === true) {
          notify(1, t("add_txt"));
          setTimeout(() => {
            window.location.replace(client + "/reclamationRetourListValider")
          }, 800);
        } else {
          saveTableCalled.current = false
          notify(2, t("erreur"));
        }
      })
    } else {
      saveTableCalled.current = false
      notify(2, t("erreur"));
    }

  };

  useEffect(() => {
    detailReclamation(idReclamation)
  }, [idReclamation, id]);

  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">{reclamation.type_reclamation == 2 ? t("claim_details") : "Détail Retour"}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <table className="table table-bordered">
                        <thead>
                          <tr className="table-info table-entete-red">
                            <th>{reclamation.type_reclamation == 2 ? t("num_claim") : "Numéro retour"}</th>
                            <th>Code {t("Wholesaler")}</th>
                            <th>{t("Wholesaler")}</th>
                            <th>{t("status")}</th>

                            {data[Object.keys(data)[0]].entete.id_type != null && <th>{t("Reclamation.type_claim")}</th>}
                            <th>Motif</th>
                            <th>Date {t("reclamation")}</th>
                            {reclamation.type_reclamation == 1 ? (
                              <>
                                <th>Code Article</th>
                                <th>{t("article")}</th>
                                <th>{t("qte_reclame") + " Grossiste"}</th>
                                <th>{t("qte_reclame")}</th>
                                <th>Quantité LOT</th>
                                <th>{t("Reclamation.numero_lot")}</th>
                                <th>Date expiration</th>
                                <th>{t("reference_bl")}</th>
                                <th>{t("date_liv")}</th>
                                <th>{t("commentaire")}</th>
                              </>
                            ) : (
                              <th>Description de la réclamation</th>
                            )}

                            <th>Pièce jointe</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(data).map((key) => {
                            const entete = data[key].entete;
                            const lignes = data[key].ligne;

                            if (reclamation.type_reclamation == 1) {
                              return lignes.map((ligne, index) => (
                                <tr key={`${key}-${index}`}>
                                  <td>{reclamation.numero}</td>
                                  <td>{reclamation.grossistes ? reclamation.grossistes.Code_client : " "}</td>
                                  <td>{reclamation.grossistes ? reclamation.grossistes.Raison_sociale : " "}</td>
                                  <td>
                                    {reclamation.etat === 0 && reclamation.type_reclamation === 2
                                      ? reclamation.status_reclamations?.nom
                                      : reclamation.etat === 1 && reclamation.type_reclamation === 2
                                        ? "Cloturée"
                                        : reclamation.traiter === 0 && reclamation.type_reclamation === 1
                                          ? "En cours de traitement par AFC"
                                          : reclamation.traiter === 1 && reclamation.type_reclamation === 1
                                            ? (reclamation.motif == 1 ? "En cours de traitement par CG" : "Traitée")
                                            : reclamation.traiter === 2 && reclamation.type_reclamation === 1
                                              ? "Traitée"
                                              : reclamation.traiter === -2 && reclamation.type_reclamation === 1
                                                ? "Refusé par CG"
                                                : "Refusé par AFC"}
                                  </td>
                                  {entete.id_type ? <td>{entete.types?.nom || ""}</td> : null}
                                  <td>{entete.motif_description}</td>
                                  <td>{reclamation.createdAt ? new Date(reclamation.createdAt).toISOString().slice(0, 10) : ""}</td>
                                  {reclamation.type_reclamation == 1 ? (
                                    <>
                                      <td><strong>{entete.produits?.Code_article || ""}</strong></td>
                                      <td><strong>{entete.produits?.Designation_1 || ""}</strong></td>
                                      <td>{ligne.quantite_grossiste}</td>
                                      <td>
                                        <Form.Control
                                          value={ligne.quantite}
                                          placeholder="Quantité"
                                          type="number"
                                          pattern="\d+"
                                          onChange={(e) => {
                                            const updatedLignes = [...lignes];
                                            const newQte = e.target.value
                                              ? parseInt(e.target.value.replace(/[^0-9]/g, ""), 10)
                                              : 0;
                                            if (newQte <= updatedLignes[index].quantite_grossiste) {
                                              updatedLignes[index].quantite = newQte;
                                              updatedLignes[index].update = 1;

                                              // Recalcul de la quantité totale
                                              const totalQte = updatedLignes.reduce((sum, l) => sum + (parseInt(l.quantite) || 0), 0);

                                              // Mise à jour des données
                                              const updatedData = { ...data };
                                              updatedData[key].ligne = updatedLignes;
                                              updatedData[key].entete.qte = totalQte;

                                              setData(updatedData);
                                            } else {
                                              notify(2, t("erreur"));
                                            }
                                          }}
                                        />
                                      </td>
                                      <td>{ligne.quantite_livraison || ""}</td>
                                      <td>{entete.lot}</td>
                                      <td>{ligne.date_expiration}</td>
                                      <td>{ligne.numero_livraison || ""}</td>
                                      <td>{ligne.Date_expedition || ""}</td>
                                    </>
                                  ) : null}
                                  <td>{entete.commentaire}</td>
                                  <td>
                                    {entete.filename && (
                                      <a
                                        className="btn btn-info"
                                        download={entete.filename}
                                        rel="noreferrer"
                                        href={Configuration.BACK_BASEURL + "reclamation/" + entete.filename}
                                        target="_blank"
                                      >
                                        <i className="fas fa-download"></i> {t("download")}
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              ));
                            } else {
                              // type_reclamation == 2
                              return (
                                <tr key={key}>
                                  <td>{reclamation.numero}</td>
                                  <td>{reclamation.grossistes ? reclamation.grossistes.Code_client : " "}</td>
                                  <td>{reclamation.grossistes ? reclamation.grossistes.Raison_sociale : " "}</td>
                                  <td>
                                    {reclamation.etat === 0 && reclamation.type_reclamation === 2
                                      ? reclamation.status_reclamations?.nom
                                      : reclamation.etat === 1 && reclamation.type_reclamation === 2
                                        ? "Cloturée"
                                        : reclamation.traiter === 0 && reclamation.type_reclamation === 1
                                          ? "En cours de traitement par AFC"
                                          : reclamation.traiter === 1 && reclamation.type_reclamation === 1
                                            ? "En cours de traitement par CG"
                                            : reclamation.traiter === 2 && reclamation.type_reclamation === 1
                                              ? "Traitée"
                                              : reclamation.traiter === -2 && reclamation.type_reclamation === 1
                                                ? "Refusé par CG"
                                                : "Refusé par AFC"}
                                  </td>
                                  {entete.id_type ? <td>{entete.types?.nom || ""}</td> : null}
                                  <td>{entete.motif_description}</td>
                                  <td>{reclamation.createdAt ? new Date(reclamation.createdAt).toISOString().slice(0, 10) : ""}</td>
                                  <td>{entete.commentaire}</td>
                                  <td>
                                    {entete.filename && (
                                      <a
                                        className="btn btn-info"
                                        download={entete.filename}
                                        rel="noreferrer"
                                        href={Configuration.BACK_BASEURL + "reclamation/" + entete.filename}
                                        target="_blank"
                                      >
                                        <i className="fas fa-download"></i> {t("download")}
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                          })}
                        </tbody>
                      </table>
                      <Row>
                        <Col md="12" className="pr-1">
                          <Form.Group>
                            <label>{t('commentaire')} </label>
                            <Form.Control
                              as={"textarea"}
                              className="form-control"
                              placeholder={t('write_comment')}
                              onChange={(e) => setCommentaire(e.target.value)}
                              rows="5"
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div>

                        {(obj.user.id_role == 5 && reclamation.traiter == 0) || (obj.user.id_role == 11 && reclamation.traiter == 1) ? <Button
                          className="btn-fill pull-right mx-2"
                          type="button"
                          variant="success" onClick={() => handleupdateRec(obj.user.id_role == 5 ? 1 : 2,reclamation.type_reclamation)}
                        >
                          {t("save&send")}
                        </Button> : null}
                        {(obj.user.id_role == 5 && reclamation.traiter == 0) || (obj.user.id_role == 11 && reclamation.traiter == 1) ? <Button
                          className="btn-fill pull-right mx-2"
                          type="button"
                          variant="danger" onClick={() => handleupdateRec(obj.user.id_role == 5 ? -1 : -2,reclamation.type_reclamation)}
                        >
                          Refuser
                        </Button> : null}

                      </div>
                      <div className="clearfix"></div>
                    </Card.Body>

                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container >
      ) : (
        ""
      )
      }
    </>
  );
}

export default ModifierReclamationAll;
